













import {MyStudyChoiceOnboardingModelState} from "@/apps/MyStudyChoiceOnboardingWidget/models/store-viewmodel"
import {ActionTree, GetterTree} from "vuex"
import {defineComponent, ref} from "@vue/composition-api"
import {useActions, useGetters} from "vuex-composition-helpers"
import SubscribedActivity from "@/apps/MyStudyChoiceActivitiesWidget/components/shared/Activity/SubscribedActivity.vue"
import ListAtom from "@/shared/components/atoms/card/ListAtom.vue"
import {formatDate} from "@/shared/filters/dates"

export default defineComponent({
    name: "SubscribeStep",
    components: {ListAtom, SubscribedActivity},
    setup: () => {
        const {getLabels} = useGetters<GetterTree<MyStudyChoiceOnboardingModelState, MyStudyChoiceOnboardingModelState>>([
            'getLabels'
        ])
        const {setCanContinue} = useActions<ActionTree<MyStudyChoiceOnboardingModelState, MyStudyChoiceOnboardingModelState>>([
            'setCanContinue'
        ])
        setCanContinue(true)

        let today = new Date
        let day = formatDate(new Date(today.setMonth(today.getMonth()+1)).toISOString(), 'dddd')
        let date = formatDate(new Date(today.setMonth(today.getMonth()+1)).toISOString(), 'D MMMM YYYY')
        let activity = ref({
            title: getLabels.value.subscribedActivityTitle,
            labels: getLabels.value,
            eventDateDescription: `${day.charAt(0).toUpperCase() + day.slice(1)} ${date}`,
            locationDescription: 'VU Campus',
            dateAfterUserCannotCancelAnymore: today.setFullYear(today.getFullYear() + 1),
            registeredEventModificationUrl: null,
            locationUrl: null,
            routeUrl: null,
            calendarUrl: null,
            participationUrl: null,
            cancellationUrl: null,
        })
        
        return {
            activity,
            getLabels,
            setCanContinue
        }
    }
})
